// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"InputBox_inputContainer__21LY1","rightIcon":"InputBox_rightIcon__2BVeJ"};